import styled from 'styled-components';

export const ContainerMsg = styled.div`
margin:0px 10px 30px 10px;
  
`;
